<p-toast></p-toast>
<div class="siteUnderMaintenance" *ngIf="isSiteUnderMaintenance">
    <div class="logo">
        <img src="assets/activitiesImages/micada_new_logo.png" alt="Logo">
    </div>
    <h1>{{ 'SITE_UNDER_MAINTENANCE' | translate }}</h1>
    <p>{{ 'SITE_UNDER_MAINTENANCE_MSG1' | translate }}</p>

    <div class="button-row">
        <button class="goback-button p-3 text-sm mx-5" pButton pRipple label="{{'GO_BACK'| translate}}" (click)="goBack()"></button>
        <button class="reload-button p-3 text-sm mx-5" pButton pRipple label="{{'RELOAD_PAGE'| translate}}" (click)="reloadPage()"></button>
    </div>

</div>
<div *ngIf="!isSiteUnderMaintenance" class="surface-0 flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
    <div class="grid justify-content-center p-2 lg:p-0" style="min-width:80%">
        <div class="col-12 mt-5 xl:mt-0 text-center">
            <!-- <img src="assets/activitiesImages/micada_new_logo.png" alt="Sakai logo" class="mb-5" style="width:100px; height:70px;"> -->
        </div>

        <div class="col-12 xl:col-6"
            style="border-radius:56px; padding:0.3rem; background: linear-gradient(180deg, #8b5815 10%, rgba(33, 150, 243, 0) 30%);">
            <div class="h-full w-full m-0 py-3 px-4"
                style="border-radius:53px; background: linear-gradient(180deg, var(--surface-50) 38.9%, var(--surface-0));">
                <div class="text-center mb-5">
                    <img src="assets/activitiesImages/micada_new_logo.png" style="mix-blend-mode: multiply;" alt="Image" height="70" class="mb-3">
                    <!-- <div class="field-checkbox justify-content-center" style="margin-right:3px;">
                        <p-dropdown [options]='[{name: "English"}, {name: "Hindi"}]' optionLabel="name"
                            (onChange)="wrongNotification($event)">
                        </p-dropdown>
                   </div>  -->

                    <div class="text-900 text-3xl font-medium mb-3">{{'WELCOME'| translate}}</div>
                    <span class="text-600 font-medium">{{'SIGN_IN_TO_CONTINUE'| translate}}</span>
                </div>
                <form [formGroup]="onAuthForm">
                    <div class="w-full md:w-10 mx-auto">
                        <label for="email1" class="block text-900 text-xl font-medium mb-2">{{'EMAIL/USERNAME'| translate}}</label>
                        <input id="email1" type="text" formControlName="email" placeholder="{{'EMAIL'| translate}}" pInputText
                            class="w-full mb-3" style="padding:1rem;">

                        <label for="password1" class="block text-900 font-medium text-xl mb-2">{{'PASSWORD'| translate}}</label>
                        <p-password id="password1" formControlName="password" placeholder="{{'PASSWORD'| translate}}" [toggleMask]="true"
                            [feedback]="false" styleClass="w-full mb-3"></p-password>

                        <div class="flex align-items-center justify-content-between mb-5">
                            <div class="flex align-items-center">
                                <p-checkbox id="rememberme1" formControlName="remembercheck" [binary]="true"
                                    styleClass="mr-2"></p-checkbox>
                                <label for="rememberme1">{{'REMEMBER_ME'| translate}}</label>
                            </div>
                            <a class="font-medium no-underline ml-2 text-right cursor-pointer"
                                [routerLink]="['/forgot-password']" style="color: var(--primary-color)">{{'FORGOT_PASSWORD'| translate}}</a>
                        </div>
                        <button pButton pRipple label="{{'SIGN_IN'| translate}}" class="sign-in-button w-full p-3 text-xl" (click)="onLogin()"></button>
                    </div>
                </form>
            </div>
        </div>

    </div>
</div>
